import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateCategory } from './types/template-category.type';

/**
 * Updates a template category by sending a PUT request to the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The template category data to update, including its ID.
 * @returns A promise that resolves to the operation result of the update.
 * @throws Will throw an error if the request fails.
 */
export const updateTemplateCategory = async (instance: KyInstance, data: TemplateCategory) => {
  try {
    return await instance
      .put<OperationResult>(formatString(Uri.template.updateTemplateCategory, data.id?.toString() ?? ''), {
        json: data,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
